/**
 * Custom override: makes the theme's live/predictive search also match on
 * product SKU (and barcode), which Shopify's Predictive Search API does not
 * search by default (unlike the full /search results page).
 *
 * This file is intentionally kept separate from the theme's core JS bundle
 * (empire.js) so it survives theme updates. It works by patching
 * `window.fetch` and appending the extra `resources[options][fields]`
 * (and `resources[type]`) parameters to any request made to the theme's
 * predictive search endpoint, without needing to touch empire.js.
 *
 * Docs: https://shopify.dev/docs/api/ajax/reference/predictive-search
 */
(function () {
  if (typeof window.fetch !== 'function') return;

  // Fields Shopify searches by default: title, product_type, variants.title, vendor.
  // We add variants.sku (and variants.barcode + tag) so SKU searches return matches.
  var CUSTOM_SEARCH_FIELDS = 'title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';
  var CUSTOM_RESOURCE_TYPES = 'product,query,collection,page';

  var originalFetch = window.fetch;

  window.fetch = function (input, init) {
    try {
      var predictiveSearchUrl = window.Theme && window.Theme.routes && window.Theme.routes.predictive_search_url;
      var requestUrl = typeof input === 'string' ? input : (input && input.url);

      if (predictiveSearchUrl && requestUrl && requestUrl.indexOf(predictiveSearchUrl) === 0) {
        var url = new URL(requestUrl, window.location.origin);

        if (!url.searchParams.has('resources[options][fields]')) {
          url.searchParams.set('resources[type]', CUSTOM_RESOURCE_TYPES);
          url.searchParams.set('resources[options][fields]', CUSTOM_SEARCH_FIELDS);

          if (typeof input === 'string') {
            input = url.toString();
          } else {
            input = new Request(url.toString(), input);
          }
        }
      }
    } catch (error) {
      // Fail silently so the search always falls back to default behavior.
    }

    return originalFetch.call(this, input, init);
  };
})();
